import { render } from "./CometChatStickerKeyboard.vue?vue&type=template&id=2cf2c586&scoped=true"
import script from "./CometChatStickerKeyboard.vue?vue&type=script&lang=js"
export * from "./CometChatStickerKeyboard.vue?vue&type=script&lang=js"

import "./CometChatStickerKeyboard.vue?vue&type=style&index=0&id=2cf2c586&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf2c586"]])

export default __exports__